export type UserIdentity = {
  email: string
  name?: string
}

export const ANONYMOUS_USER = 'anonymous'
